import { Stack, Text } from "@fluentui/react";
import { FontSizes, FontWeights } from "@fluentui/theme";

const Lobby: React.FC<{}> = () => {
  return (
    <Stack>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
        }}
      >
        <Text
          style={{
            marginBottom: 20,
            fontWeight: FontWeights.bold,
            fontSize: FontSizes.size68,
          }}
        >
          Please wait...
        </Text>
        <Text style={{ fontSize: FontSizes.size32 }}>
          The examiner will bring you into the exam room shortly
        </Text>
      </div>
    </Stack>
  );
};

export default Lobby;
